import { Selector } from 'react-redux';

import { createSelector } from 'reselect';

export const calcPageCount = (totalItems: number, itemsPerPage: number): number =>
  Math.ceil(totalItems / itemsPerPage);

export const getPageCount = (getItemsTotal: Selector<any, number>, itemsPerPage: number) =>
  createSelector([getItemsTotal], (totalItems: number): number =>
    calcPageCount(totalItems, itemsPerPage)
  );
